import { Flex, Icon, Stack, TFText } from '@tf/ui';
import type React from 'react';
import { useState } from 'react';

interface Props {
	onClick: () => void;
	title: string;
	style?: React.CSSProperties;
	size?: 'sm' | 'md';
}

export const ActionButton: React.FC<Props> = ({ onClick, title, style, size = 'md' }) => {
	const [isHovered, setIsHovered] = useState(false);

	return (
		<Flex
			onClick={onClick}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			align="center"
			sx={{
				cursor: 'pointer',
				width: '100%',
				padding: size === 'sm' ? '8px 12px' : '12px',
				borderRadius: '4px',
				transition: 'background-color 0.2s',
				backgroundColor: '#EFF6FF',
				border: `1px solid #fff`,
				'&:hover': {
					backgroundColor: '#DBEAFE',
					border: `1px solid #E5E7EB`,
				},
				'&:active': {
					transform: 'translateY(1px)',
				},
			}}
			style={style}
		>
			<Flex w="100%" align="center">
				<Flex align="center" h={size === 'md' ? '36px' : undefined}>
					<Flex
						justify="center"
						align="center"
						w={size === 'md' ? '28px' : '24px'}
						h={size === 'md' ? '28px' : '24px'}
						bg={isHovered ? '#1E40AF' : '#1D4ED8'}
						mr="12px"
						sx={{ borderRadius: '50%' }}
					>
						<Icon.IconPlus fill="#2563EB" color="white" size={size === 'md' ? 24 : 20} />
					</Flex>
				</Flex>
				<Stack gap="4px">
					<TFText c={isHovered ? '#1E40AF' : '#1D4ED8'} fz="16px" lh="20px" fw="500">
						{title}
					</TFText>
				</Stack>
			</Flex>
		</Flex>
	);
};
